import C from './constants'
// import { v4 } from 'uuid'

export const changeTheme = (theme, userWindow) =>
(
    {
        type: C.CHANGE_THEME,
        theme,
        userWindow
    }
) 

export const simulate = (simDisplay) =>
(
    {
        type: C.SIMULATE,
        simDisplay
    }
) 

export const changeViz = (chartSelected) =>
(
    {
        type: C.CHANGE_VIZ,
        chartSelected
    }
)

export const updatePalette = (id, color, selected, userWindow) =>
(
    {
        type: C.UPDATE_PALETTE,
        id: id,
        selected,
        color,
        userWindow
    }
)

export const trashAll = () =>
(
    {
        type: C.TRASH_ALL
    }
)

export const randomizeColors = (colorArr, userWindow) =>
{

    //get list of all IDs in one array
    let allIdObj = []
    colorArr.map((colorRowObj) => colorRowObj.colorArr.map((colorObj) => allIdObj.push({id: colorObj.id,
                                                                                        color: colorObj.color})))

    //creating random array numbers
    let randomNum = [];
    while(randomNum.length < 10){
        let r = Math.floor(Math.random()*allIdObj.length);
        if(randomNum.indexOf(r) === -1){
          randomNum.push(r)
        };
    }

    let randomIdsObj = allIdObj.filter((d, i) => randomNum.includes(i))
    return (
    {
        type: C.RANDOMIZE_COLORS,
        randomIdsObj,
        userWindow
    }
    )
}

export const removePalette = (colorRowId) =>
(
    {
        type: C.REMOVE_PALETTE,
        colorRowId
    }
)

export const selectAllColors = (colorArr, colorRowId, selectAll, userWindow) =>
(
    {
        type: C.SELECT_ALL_COLORS,
        colorRowId,
        selectAll,
        colorArr,
        userWindow
    }
)

export const addColorPalette = (startHex, endHex, userWindow) =>
(
    {
        type: C.ADD_COLOR_PALETTE,
        startHex,
        endHex,
        userWindow
    }
)

export const subtractColorPalette = () =>
(
    {
        type: C.SUBTRACT_COLOR_PALETTE
    }
)

export const changeMedia = () =>
(
    {
        type: C.CHANGE_MEDIA
    }
)

export const updateColorAttr = (userWindow) =>
(
    {
        type: C.UPDATE_COLOR_ATTR,
        userWindow
    }
)

export const copyColorToClipboard = (colorClicked) =>
(
    {
        type: C.COPY_COLOR_TO_CLIPBOARD,
        colorClicked
    }
)

export const downloadCsv = (userWindow, userPalette) =>
(
    {
        type: C.DOWNLOAD_CSV,
        userWindow, 
        currUserPalette: userPalette,
    }
)

export const downloadJson = (userWindow, userPalette) =>
(
    {
        type: C.DOWNLOAD_JSON,
        userWindow, 
        currUserPalette: userPalette,
    }
)

export const downloadArr = (userWindow, userPalette) =>
(
    {
        type: C.DOWNLOAD_ARR,
        userWindow, 
        currUserPalette: userPalette,
    }
)

export const downloadJpeg = (userWindow, userPalette, theme) =>
(
    {
        type: C.DOWNLOAD_JPEG,
        userWindow, 
        currUserPalette: userPalette,
        currTheme: theme
    }
)

export const downloadViz = (userWindow, theme, chartSelected, imgFormat) =>
(
    {
        type: C.DOWNLOAD_VIZ,
        userWindow,
        currTheme: theme,
        currChartSelected: chartSelected,
        imgFormat
    }
)

// export const downloadVizPng = (userWindow) =>
// (
//     {
//         type: C.DOWNLOAD_JPEG,
//         userWindow,
//     }
// )
